module.exports = __webpack_public_path__ + "img/card-avatar-silver.f3534d34.png";